module.exports = __webpack_public_path__ + "img/obat-imfinzi.869b9119.png";